module.exports = __webpack_public_path__ + "media/images/chat-banner-9fc2a461.png";